import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "./constants";

export default function TechnicianLogin() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [forgotMode, setForgotMode] = useState(false);
  const [pan, setPan] = useState("");
  const [recoveryPassword, setRecoveryPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await fetch(
        `${AIRTABLE_URL_TECHNICIAN}?filterByFormula={phone}='${phone}'`,
        {
          headers: AIRTABLE_HEADERS, // ✅ centralized headers
        }
      );

    const data = await res.json();
    const record = data.records[0];

    if (!record) {
      alert("❌ Technician not found.");
      return;
    }

    const savedPassword = record.fields.password;

    if (savedPassword === password) {
      localStorage.setItem("technicianPhone", phone);
      localStorage.setItem("technicianLoggedIn", "true");

      // ✅ Navigate with phone as state
      navigate("/technician-home", { state: { technicianPhone: phone } });
    } else {
      alert("❌ Incorrect password.");
    }
  } catch (error) {
    console.error("Login error:", error);
    alert("Something went wrong. Try again.");
  }
};

  const handleForgotPassword = async () => {
    if (!phone || !pan) {
      alert("Please enter both phone and PAN card number.");
      return;
    }

   try {
      const res = await fetch(
        `${AIRTABLE_URL_TECHNICIAN}?filterByFormula=AND({phone}='${phone}', {pan}='${pan}')`,
        {
          headers: AIRTABLE_HEADERS, // ✅ centralized headers
        }
      );

      const data = await res.json();
      const record = data.records[0];

      if (record) {
        setRecoveryPassword(record.fields.password);
      } else {
        setRecoveryPassword("❌ No match found for the provided details.");
      }
    } catch (error) {
      console.error("Forgot Password error:", error);
      alert("Something went wrong while verifying.");
    }
  };

  return (
    <div style={{ padding: 40, position: "relative" }}>
      {/* X Button */}
      <button
        onClick={() => navigate("/")}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          color: "black",
        }}
      >
        ✖
      </button>

      <h2>Technician Sign In</h2>

      {!forgotMode ? (
        <>
          <input
            type = "tel"
            inputMode= "numeric"
            placeholder="Enter Mobile Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            maxLength={10}
            style={{ padding: 10, marginBottom: 10, width: "100%" }}
          />

          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ padding: 10, marginBottom: 10, width: "100%" }}
          />

          <button
            onClick={handleLogin}
            style={{ marginBottom: 10, padding: 10, width: "109%" }}
          >
            Sign In
          </button>

          <button
            onClick={() => setForgotMode(true)}
            style={{
              background: "transparent",
              border: "none",
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Forgot Password?
          </button>
        </>
      ) : (
        <>
          <input
            type = "tel"
            inputMode= "numeric"
            placeholder="Enter Registered Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            maxLength={10}
            style={{ padding: 10, marginBottom: 10, width: "100%" }}
          />

          <input
            placeholder="Enter PAN Card Number in UPPER CASE"
            value={pan}
            onChange={(e) => setPan(e.target.value)}
            style={{ padding: 10, marginBottom: 10, width: "100%" }}
          />

          <button
            onClick={handleForgotPassword}
            style={{ marginBottom: 10, padding: 10, width: "109%" }}
          >
            Recover Password
          </button>

          <button
            onClick={() => {
              setForgotMode(false);
              setRecoveryPassword("");
              setPan("");
            }}
            style={{
              background: "transparent",
              border: "none",
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Back to Login
          </button>

          {recoveryPassword && (
            <div style={{ marginTop: 15, fontWeight: "bold" }}>
              🔐 Your Password:{" "}
              <span style={{ color: "green" }}>{recoveryPassword}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
